/** @format */

import React from "react";
import { Route, Routes } from "react-router-dom";
import About from "../../pages/About";
import Contact from "../../pages/Contact";
import Faqs from "../../pages/Faqs";
import Home from "../../pages/Home";
import Mission from "../../pages/Mission";
import PrivacyModel from "../../pages/PrivacyModel";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import TermsOfService from "../../pages/TermsOfService";
import Dashboard from "../../pages/Admin/Dashboard";

export default function Naigation() {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/faqs' element={<Faqs />} />
      <Route path='/mission' element={<Mission />} />
      <Route path='/privacy-model' element={<PrivacyModel />} />
      <Route path='/legal-privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms-of-Service' element={<TermsOfService />} />
      {/* Admin Routes */}
      <Route path='/dashboard' element={<Dashboard />} />
    </Routes>
  );
}
